<template>
	<div class="card">
		<div class="card-header bg-dark d-flex justify-content-between align-items-center">
			<h3 class="mb-0 text-white">ตั้งค่าระบบถอนเข้าบัญชีกลาง</h3>

			<base-button type="secondary" @click="modalOpen = true">
				ประวัติการโอนเงิน
			</base-button>
		</div>
		<div class="card-body">
			<form @submit.prevent="saveConfig">
				<base-input
					label="ยอดคงเหลือขั้นต่ำ"
					placeholder="ยอดคงเหลือขั้นต่ำ"
					v-model.number="setting.minAmount"
				/>
				<base-input
					label="เลขบัญชีกลาง"
					placeholder="เลขบัญชีกลาง"
					v-model="setting.accountNumber"
				/>
				<base-input label="ธนาคาร">
					<el-select v-model="setting.bankCode" placeholder="ธนาคาร">
						<el-option label="ธนาคารไทยพาณิชย์" value="SCB" />
						<el-option label="ธนาคารกสิกรไทย" value="KBANK" />
						<el-option label="ธนาคารกรุงศรีอยุธยา" value="BAY" />
						<el-option label="ธนาคารกรุงเทพ" value="BBL" />
						<el-option label="ธนาคารออมสิน" value="GSB" />
						<el-option label="ธนาคารกรุงไทย" value="KTB" />
					</el-select>
				</base-input>

				<div class="mt-3">
					<base-button
						native-type="submit"
						type="default"
						class="mt-2"
						:disabled="loading"
					>
						บันทึกข้อมูล
					</base-button>
				</div>
			</form>
		</div>

		<auto-table :open="modalOpen" @close="modalOpen = false" />
	</div>
</template>

<script>
import SettingService from '../../services/setting.service'

import { Select, Option } from 'element-ui'
import AutoTable from './AutoTable'

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		AutoTable,
	},
	data() {
		return {
			loading: false,
			modalOpen: false,

			setting: {},
		}
	},
	methods: {
		saveConfig() {
			this.loading = true
			SettingService.saveSCBAuto(this.setting)
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	created() {
		SettingService.getSCBAuto().then((res) => {
			this.setting = res.setting
		})
	},
}
</script>
